/*
* @描述: 添加成员
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2025/3/24 17:12
*/
<template>
  <van-popup v-model="dialogVisible"
             :style="{ width: '100%',height: '100%' }">
    <div class="public_container">
      <div class="returnNavBar">
        <ReturnNavBar :isAllFunctions="false"
                      :isCustomReturnEvent="true"
                      :isTitleNormal="true"
                      title="返回"
                      @returnEvent="handleDialogClose"></ReturnNavBar>
      </div>
      <div class="detail_wrap_container padding_10">
        <van-form ref="teamMembersAddForm" error-message-align="right" input-align="right">
          <van-field :rules="teamMembersAddFormRules.member_uid"
                     :value="teamMembersAddForm.member_name"
                     is-link
                     label="选择成员"
                     placeholder="请选择成员"
                     readonly
                     required
                     @click="memberSelectVisible=true">
          </van-field>
          <van-field label="权限类型">
            <template #input>
              <el-radio-group v-model="teamMembersAddForm.auth">
                <el-radio :label="1">只读</el-radio>
                <el-radio :label="2">读写</el-radio>
              </el-radio-group>
            </template>
          </van-field>
        </van-form>
      </div>
      <div class="add_footer_wrap">
        <van-button size="large"
                    type="primary"
                    @click="handleDialogConfirm">提交
        </van-button>
      </div>
      <UserSearchSelect v-if="memberSelectVisible"
                        :userSelectVisible="memberSelectVisible"
                        @selectUserData="getSelectUserData"/>
    </div>
  </van-popup>
</template>
<script>
import {projectMemberAdd} from "@/api";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import UserSearchSelect from "@/components/mComponents/UserSearchSelect"

export default {
  name: "BusinessAddMember",
  components: {ReturnNavBar, UserSearchSelect},
  data() {
    return {
      teamMembersAddForm: {
        member_uid: 0,
        member_name: '',
        auth: 2
      },
      teamMembersAddFormRules: {
        member_uid: [
          {
            required: true,
            message: '请选择成员',
            trigger: 'onChange',
            validator: (value) => {
              return this.teamMembersAddForm.member_uid !== 0
            }
          }
        ]
      },
      userOptions: [],
      memberSelectVisible: false,
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    project_ids: {
      type: Array,
      default: () => []
    }
  },
  created() {
  },
  methods: {

    getSelectUserData(data) {
      this.teamMembersAddForm.member_uid = data.uid
      this.teamMembersAddForm.member_name = data.name
      this.memberSelectVisible = false
    },

    // 关闭弹窗
    handleDialogClose() {
      this.$emit('update:dialogVisible', false)
    },

    // 确定
    handleDialogConfirm() {
      this.$refs.teamMembersAddForm.validate().then(() => {
        projectMemberAdd({
          project_ids: this.project_ids,
          member_uid: this.teamMembersAddForm.member_uid,
          auth: this.teamMembersAddForm.auth
        }).then(res => {
          if (res.code === 200) {
            this.$toast.success('添加成功')
            this.$emit('update:dialogVisible', false)
            this.$emit('refresh')
          } else {
            this.$toast(res.message)
          }
        })
      }).catch((error) => {
        this.$toast.fail(error[0].message)
      })
    },
  },
}
</script>
<style lang="scss" scoped>

</style>